import { iconsNames } from "@jti/ui/components/EcommerceReassuranceBanner";

type IconKey = (typeof iconsNames)[number];

export const dropdownMapper: Record<string, IconKey> = {
  Account: "account",
  "Check + round": "checkMarkWithRoundBorder",
  "Credit card + lock": "cardWithLock",
  Edit: "edit",
  "Falling plus": "falling",
  "No smoke smell": "noSmokeSmell",
  Package: "package",
  "Package + arrow": "packageWithArrow",
  "Package + checkmark": "packageWithCheckMark",
  "Package + clock": "packageWithClock",
};
